export const getPlanFromCredentials = (credentials: string) =>
    credentials.substring(credentials.length - 3) === ":fx" ? "free" : "pro";
